module.exports = __webpack_public_path__ + "static/img/10.b22e3c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/sp/10.png
// module id = u+oa
// module chunks = 0